import React from 'react'
import TypesFood from '../components/TypesFood'
import Marque from '../components/Marque'
import Footer from '../components/Footer'
import ProductSection from '../components/ProductSection'

const ProductsMobile = () => {
  return (
    <div className='w-full flex flex-col gap-6 sm:gap-8 md:gap-10 lg:gap-12'>
        <ProductSection isMob={true}/>
        <TypesFood/>
        <Marque 
            padd='px-6 sm:px-20 md:px-28 lg:px-36 w-full  aspect-[16/3] lg:aspect-[16/2]'
            motherclassName='w-full h-full flex flex-row  justify-around items-center bg-primary02'
            className1='text-[10px] xs:text-[15px] sm:text-[18px] md:text-[20px] lg:text-[25px]'
          />
        <Footer/>
    </div>
  )
}

export default ProductsMobile